export default __webpack_public_path__ + "static/media/review-img-5.3e3c3d0a.png";